import { commonActions } from "../../redux/reducers/CommonReducer";
import store from "../../redux/Store";
import { trackException } from "../../services/Azure/ApplicationInsightsActions";
import AxiosInstance from "./AxiosInstance";

export const HEAD = (url, queryParams = "") => {
  store.dispatch(commonActions.setIsShowLoadingSpinner(true));
  return new Promise((resolve, reject) => {
    AxiosInstance.head(url + queryParams, { withCredentials: true })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("AxiosActions.js - HEAD()", error);
        reject(error);
      })
      .finally(() => {
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      });
  });
};

export const GET = (url, queryParams = "", isShowSpinner = true, closeSpinner = true) => {
  store.dispatch(commonActions.setIsShowLoadingSpinner(isShowSpinner));

  return new Promise((resolve, reject) => {
    AxiosInstance.get(url + queryParams, { withCredentials: true })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("AxiosActions.js - GET()", error);
        reject(error);
      })
      .finally(() => {
        if (closeSpinner) {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      });
  });
};

export const POST = (url, body, isShowSpinner = true, closeSpinner = true) => {
  store.dispatch(commonActions.setIsShowLoadingSpinner(isShowSpinner));

  return new Promise((resolve, reject) => {
    AxiosInstance.post(url, body, { withCredentials: true })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("AxiosActions.js - POST()", error);
        reject(error);
      })
      .finally(() => {
        if (closeSpinner) {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      });
  });
};

export const PUT = (url, body, isShowSpinner = true, closeSpinner = true) => {
  store.dispatch(commonActions.setIsShowLoadingSpinner(isShowSpinner));
  return new Promise((resolve, reject) => {
    AxiosInstance.put(url, body, { withCredentials: true })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("AxiosActions.js - PUT()", error);
        reject(error);
      })
      .finally(() => {
        if (closeSpinner) {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      });
  });
};

export const PATCH = (url, body, isShowSpinner = true, closeSpinner = true) => {
  store.dispatch(commonActions.setIsShowLoadingSpinner(isShowSpinner));
  return new Promise((resolve, reject) => {
    AxiosInstance.patch(url, body, { withCredentials: true })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("AxiosActions.js - PATCH()", error);
        reject(error);
      })
      .finally(() => {
        if (closeSpinner) {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      });
  });
};

export const DELETE = (url, body = null, isShowSpinner = true, closeSpinner = true) => {
  store.dispatch(commonActions.setIsShowLoadingSpinner(isShowSpinner));
  return new Promise((resolve, reject) => {
    AxiosInstance.delete(url, { data: body, withCredentials: true })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("AxiosActions.js - DELETE()", error);
        reject(error);
      })
      .finally(() => {
        if (closeSpinner) {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      });
  });
};
